export default __webpack_public_path__ + "static/media/perereka-maringa.86274586.jpeg";